import styled from 'styled-components';

export const StakingContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-inline: 15px;
    min-height: 110vh;
    font-weight: bolder;
`

export const StakingTopCard = styled.div`
    display: flex;
    flex-direction: column;
    margin-block-start: 20px;
    font-weight: bold;
`

export const StakingBalanceCard = styled.div`
    display: flex;
    justify-content: space-between;
    margin-block: 5px;
`

export const StakingBalanceButton = styled.button`
    display: flex;
    justify-content: space-evenly;
    border-radius: 10px;
    width: calc(100% - 10px);
    height: 50px;
    font-weight: bold;
    margin-inline: 5px;

    & > svg{
        fill: ${({theme}) => theme.colors.primary}
    }
`

export const StakingCardContainer = styled.div`
    margin-top: 30px;
`

export const StakingCard = styled.div`
    display: flex;
    justify-content: space-between;
    border: 1px solid #7B36EE;
    border-radius: 10px;
    padding: 10px 30px;
    margin-block: 10px;
    background-color: ${({theme}) => theme.colors.primary};
    cursor: pointer;

`

export const StakingBuyCardContainer = styled.div`
    position: fixed;
    top: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.45);

    @media only screen and (min-width: 500px){
        width: 500px;
    }
`
export const StakingBuyCard = styled(StakingCard)`
    flex-direction: column;
    width: 100vw;
    margin-inline: 10px;
    cursor: default;
`